import styled from "styled-components";

function AtributeFilter() {
    return(Atribute)
}

const Atribute = [
    ["Atributo", "", ""],
    ["HP","HP","HP"],
    ["SP","SP","SP"],
    ["FOR","FOR","STR"],
    ["AGI","AGI","AGI"],
    ["VIT","VIT","VIT"],
    ["INT","INT","INT"],
    ["DES","DES", "DEX"],
    ["SOR","SOR", "Luck"],
    ["ATQ", "Ataque", "Atk"],
    ["Conjuração Fixa","Conjuração Fixa", "Fixed Cast"],
    ["Conjuração Variável","Conjuração Variável", "Variable Cast"],
    ["ASPD","ASPD", "ASPD"],
    ["Velocidade de Ataque","Velocidade de Ataque", "Atack Speed"]
]

export default AtributeFilter;